<script>
  import { layoutMethods } from "@/state/helpers";
  import flatPickr from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import moment from 'moment-timezone';
  import Swal from 'sweetalert2';

  import { smartRaffleMethods } from "@/state/helpers"; // Import the methods for API connection


  /**
   * Raffle Identifier component
   */
  export default {
    page: {
      title: "Raffle Identifier"
    },
    components: {
      flatPickr
    },
    computed: {
    },
    data() {
      return {
        title: "Raffle Identifier",
        raffleDetails: {
          id: null,
          raffleIdentifier: null,
          drawDate: null,
          promoDuration: null,
          promoStartDate: null,
          promoEndDate: null
        },
        raffleFormValidation: {
          raffleIdentifier: false,
          drawDate: false,
          promoDuration: false
        },
        incrementEndDate: null,
        isSubmitted:false,
        isLoading: true,
        isAddMode: true,
        isEditMode: false,
        raffleIdentifierList: [],
        fieldsRaffleIdentifierList: [
          {
            key: 'action',
            sortable: false,
            thStyle: { width: "15%" },
          },
          {
            key: 'raffleIdentifierName',
            sortable: true,
            label: 'Raffle Identifier Name',
            thStyle: { width: "30%" },
          },
          {
            key: 'raffleDuration',
            sortable: true,
            label: 'Promo Duration',
            thStyle: { width: "20%" },
          },
          {
            key: 'raffleDrawDate',
            sortable: true,
            label: 'Draw Date',
            thStyle: { width: "20%" },
          },
        ],
        minDate: 'today',
        dateToday: moment().format("YYYY-MM-DD"),
        rangeOptions: {
          mode: "range",
          minDate: "today"
        },
      };
    },
    methods: {
      ...layoutMethods,
      ...smartRaffleMethods,
      checkForm(mode) {
        let paramFormMode = mode;
        let status = true;

        this.raffleFormValidation.raffleIdentifier = false;
        this.raffleFormValidation.drawDate = false;
        this.raffleFormValidation.promoDuration = false;

        if(this.isEmpty(this.raffleDetails.raffleIdentifier) == true) {
          status = false;
          this.raffleFormValidation.raffleIdentifier = true;
        }

        if(this.checkDate(this.raffleDetails.drawDate) == false) {
          status = false;
          this.raffleFormValidation.drawDate = true;
        }

        if(this.checkDateRange(this.raffleDetails.promoDuration) == false) {
          status = false;
          this.raffleFormValidation.promoDuration = true;
        }

        if (status) { 
          this.isSubmitted = true;

          if (paramFormMode == "add") {
            this.submitNewRaffleIdentifer();
          }
          else if (paramFormMode == "edit") {
            this.submitEditedRaffleIdentifer();
          }
        }
        
      },
      checkDate(date) {
        // if(date == null){return false;}
        // var d = new Date(date);
        //   // An invalid date object returns NaN for getTime() and NaN is the only
        //   // object not strictly equal to itself.
        //   return d.getTime() === d.getTime();

        let paramDate = date;
        let convertDate = moment(date);

        // Validate normal date
        if (convertDate.isValid()) {
          return true;
        } 
        else if (paramDate == null) {
          return false;
        }
        else {
          return false;
        }
      },
      checkDateRange(date) {
        let paramDate = date;

        // Validate date range
        if (paramDate != null) {
          let dates = paramDate.split(' to '),
              startDate = dates[0] || '',
              endDate = dates[1] || '';

          if (startDate == null) {
            this.raffleDetails.promoDuration = null;
            return false;
          }

          // This will allow 1-day promo duration
          if (this.isEmpty(endDate)) {
            endDate = startDate
          }

          if (moment(startDate).isValid() && moment(endDate).isValid()) {
            this.raffleDetails.promoStartDate = startDate
            this.raffleDetails.promoEndDate = endDate

            this.incrementEndDate = moment(endDate).add(1, "days").format("YYYY-MM-DD")
            return true;
          }
          else {
            return false;
          }
        }
        else {
          return false;
        }
      },
      isEmpty(value){
        return (
        // null or undefined
        (typeof value == "undefined") || 
        (value == undefined) ||
        (value == null) ||
        (value === "") ||
        // has length and it's zero
        (Object.prototype.hasOwnProperty.call(value,'length') && value.length === 0) ||
        // is an Object and has no keys
        (value.constructor === Object && Object.keys(value).length === 0)
        )
      },
      checkChangedValue(data) {
        switch (data) {
          case "raffleIdentifier":
            this.raffleFormValidation[data] = this.isEmpty(this.raffleDetails[data]);
            break;

          case "drawDate": {
            // this.raffleFormValidation[data] = this.checkDate(this.raffleDetails[data]);

            let element = document.getElementById("date-draw-date");
            this.raffleDetails.drawDate = element.value
          
            this.raffleFormValidation.drawDate = false; 
            if (this.checkDate(this.raffleDetails.drawDate) == false) {
              this.raffleFormValidation.drawDate = true;
            }
            break;
          }
          
          case "promoDuration": {
            // this.raffleFormValidation[data] = this.checkDate(this.raffleDetails[data]);

            let element = document.getElementById("date-promo-duration");
            this.raffleDetails.promoDuration = element.value
          
            this.raffleFormValidation.promoDuration = false; 
            if (this.checkDateRange(this.raffleDetails.promoDuration) == false) {
              this.raffleFormValidation.promoDuration = true;
            }
            break;
          }
        
          default:
            break;
        }
      },
      async submitNewRaffleIdentifer() {
        let requestPayload = {
          identifier_name: this.raffleDetails.raffleIdentifier,
          raffle_start: this.raffleDetails.promoStartDate,
          raffle_end: this.raffleDetails.promoEndDate,
          raffle_draw_date: moment(this.raffleDetails.drawDate).format("YYYY-MM-DD HH:mm:ss"),
        }

        await this.actionSmartRaffle({
            action: "create-raffle-identifier",
            body: { ...requestPayload }
        }).then((res) => {
          let responseData = res["message"]

          if (responseData.statusCode == 201) {
            // Swal.fire("Added Successfully!", `${this.raffleDetails.raffleIdentifier} has been added.`, "success");
            Swal.fire({
              title: `${responseData.title}`,
              html: `${responseData.message}`,
              icon: "warning",
              showCancelButton: false,
              confirmButtonColor: "#fff",
              confirmButtonText: "OK",
              customClass: {
                confirmButton: 'btn-confirm',
              }
            }).then((result) => {
              if (result.isConfirmed) {
                this.isSubmitted = false
              }
            });
          }
          else { // If there's no duplicate Raffle Promo Duration, create new record successful
            Swal.fire({
              title: "Added Successful!",
              html: `<b>${this.raffleDetails.raffleIdentifier}</b> has been added.`,
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#fff",
              confirmButtonText: "OK",
              customClass: {
                confirmButton: 'btn-confirm',
              }
            }).then((result) => {
              if (result.isConfirmed) {
                this.isAddMode = true;
                this.isEditMode = false;
                this.getRaffleIdentiferList();
                this.clearForm();
              }
            });
          }
          
        }).catch((err) => {
            console.error("err", err);
        })
        
      },
      async submitEditedRaffleIdentifer() {
        let requestPayload = {
          "id": this.raffleDetails.id,
          "identifier_name": this.raffleDetails.raffleIdentifier,
          "raffle_start": this.raffleDetails.promoStartDate,
          "raffle_end": this.raffleDetails.promoEndDate,
          "raffle_draw_date": moment(this.raffleDetails.drawDate).format("YYYY-MM-DD HH:mm:ss"),
        }

        await this.actionSmartRaffle({
            action: "update-raffle-identifier",
            body: { ...requestPayload }
        }).then((res) => {
          let responseData = res["message"]

          if (responseData.statusCode == 201) {
            // Swal.fire("Update Successful!", `${this.raffleDetails.raffleIdentifier} has been updated.`, "success");
            Swal.fire({
              title: `${responseData.title}`,
              html: `${responseData.message}`,
              icon: "warning",
              showCancelButton: false,
              confirmButtonColor: "#fff",
              confirmButtonText: "OK",
              customClass: {
                confirmButton: 'btn-confirm',
              }
            }).then((result) => {
              if (result.isConfirmed) {
                this.isSubmitted = false
              }
            });
          }
          else { // If there's no duplicate Raffle Promo Duration, update record successful
            Swal.fire({
              title: "Update Successful!",
              html: `<b>${this.raffleDetails.raffleIdentifier}</b> has been updated.`,
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#fff",
              confirmButtonText: "OK",
              customClass: {
                confirmButton: 'btn-confirm',
              }
            }).then((result) => {
              if (result.isConfirmed) {
                this.isAddMode = true;
                this.isEditMode = false;
                this.getRaffleIdentiferList();
                this.clearForm();
              }
            });
          }
          
        }).catch((err) => {
            console.error("err", err);
        })
        
      },
      editRaffleIdentifier(item) {
        this.isAddMode = false;
        this.isEditMode = true;

        let paramItem = item
        
        this.raffleDetails.id = paramItem.raffleIdentifierId
        this.raffleDetails.raffleIdentifier = paramItem.raffleIdentifierName
        this.raffleDetails.promoDuration = paramItem.raffleDuration
        this.raffleDetails.drawDate = moment(paramItem.raffleDrawDate).format('YYYY-MM-DD hh:mm A')
      },
      cancelEditRaffleIdentifier() {
        this.isAddMode = true;
        this.isEditMode = false;
        this.clearForm();
      },
      deleteRaffleIdentifier(item) {
        let paramItem = item

        let requestPayload = {
          "id": paramItem.raffleIdentifierId
        }

        Swal.fire({
          title: "Delete Raffle Identifier?",
          html: `Are you sure you want to delete <b>${paramItem.raffleIdentifierName}</b>?`,
          icon: "question",
          showCancelButton: true,
          cancelButtonText: "Cancel",
          confirmButtonColor: "#c4297c",
          cancelButtonColor: "#804997",
          confirmButtonText: "Confirm",
        }).then(async (result) => {
          if (result.isConfirmed) { //deleted successfully
            // Swal.fire("Success!", `Deleted successfully.`, "success");

            await this.actionSmartRaffle({
                action: "delete-raffle-identifier",
                body: { ...requestPayload }
            }).then((res) => {
              console.log("RESULT: ", res)

              Swal.fire({
                title: "Success!",
                text: "Deleted successfully.",
                icon: "success",
                showCancelButton: false,
                confirmButtonColor: "#fff",
                confirmButtonText: "OK",
                customClass: {
                  confirmButton: 'btn-confirm',
                }
              }).then((result) => {
                if (result.isConfirmed) {
                  this.getRaffleIdentiferList();
                }
              });
            }).catch((err) => {
                console.error("err", err);
            })

          }
        });
        
      },
      clearForm() {
        this.isSubmitted = false
        this.raffleDetails.raffleIdentifier = null
        this.raffleDetails.drawDate = null
        this.raffleDetails.promoDuration = null
        this.raffleDetails.promoStartDate = null
        this.raffleDetails.promoEndDate = null

        setTimeout(() => {
            this.raffleFormValidation.raffleIdentifier = false;
            this.raffleFormValidation.drawDate = false;
            this.raffleFormValidation.promoDuration = false;
        }, 30);
      },
      formatDate(value){
        return moment(value).format('YYYY-MM-DD hh:mm:ss A');
      },
      isDisableEdit(value) {
        let dateToCheck = moment(value).format("YYYY-MM-DD")

        return (dateToCheck <= this.dateToday) ? true : false;
      },
      async getRaffleIdentiferList() {
        await this.actionSmartRaffle({
            action: "active-raffle-identifier-list",
            body: { 
              hideExpiredPromo: false
            }
        }).then((res) => {
            this.isLoading = false

            // this.raffleIdentifierList = res.message
            this.raffleIdentifierList = res["message"].map(raffle => { 
              return { 
                ...raffle,
                raffleDuration: raffle.raffleStartDate + " to " + raffle.raffleEndDate
              }
            });
            
        }).catch((err) => {
            console.error("err", err);
        })
      },
    },
    async mounted(){
      // alert("hey Raffle Identifier");
      this.getRaffleIdentiferList();
    }
  }
</script>



<template>
  <div class="row"><!-- outer div-->
    <div class="col-md-5 col-12" v-if="isAddMode"> <!-- start of Add Raffle Identifier main div -->
      <div class="card">
        <div class="card-header text-dark fw-bold">
          Add Raffle Identifier
        </div>
        <div class="card-body">
          <ValidationObserver v-slot="{ handleSubmit, reset }">
            <b-form @submit.prevent="handleSubmit(checkForm('add'))"
                    @reset.prevent="reset">

              <div class="col-md-12">
                <label>Raffle Identifier Name <span class="text-danger">*</span></label>
                <b-form-input placeholder="Enter Raffle Identifier"
                              v-model="raffleDetails.raffleIdentifier"
                              class="form-control"
                              :class="{
                                  'is-invalid' : raffleFormValidation.raffleIdentifier
                              }"
                              @change="checkChangedValue('raffleIdentifier')"
                              trim
                ></b-form-input>
                <div v-if="raffleFormValidation.raffleIdentifier"
                     class="invalid-feedback">
                     This field is required
                </div>
              </div> <!-- End of raffleIdentifier field -->

              <div class="col-md-12 mt-3">
                <label class="form-label">Promo Duration <span class="text-danger">*</span></label>
                <flat-pickr placeholder="Select a date"
                            v-model="raffleDetails.promoDuration"
                            :config="rangeOptions"
                            class="form-control"
                            :class="{
                                'is-invalid' : raffleFormValidation.promoDuration
                            }"
                            @on-change="checkChangedValue('promoDuration')"
                            id="date-promo-duration"
                            required
                ></flat-pickr>
                <div v-if="raffleFormValidation.promoDuration"
                     class="invalid-feedback">
                     This field is required
                </div>
              </div> <!-- End of promoDuration field -->

              <div class="col-md-12 mt-3">
                <label class="form-label">Draw Date <span class="text-danger">*</span></label>
                <flat-pickr placeholder="Select a date"
                            v-model="raffleDetails.drawDate"
                            :config="{ minDate: raffleDetails.promoStartDate ? incrementEndDate : minDate, 
                                       maxDate: null, 
                                       enableTime: true, 
                                       dateFormat: 'Y-m-d h:i K' }"
                            class="form-control"
                            :class="{
                                'is-invalid' : raffleFormValidation.drawDate
                            }"
                            @on-change="checkChangedValue('drawDate')"
                            id="date-draw-date"
                            required
                ></flat-pickr>
                <div v-if="raffleFormValidation.drawDate"
                     class="invalid-feedback">
                     This field is required
                </div>
              </div> <!-- End of drawDate field -->
              
              <div class="mt-4">
                <b-button class="w-100"
                          type="submit"
                          variant="primary"
                          :disabled="isSubmitted">
                  <span v-if="isSubmitted"
                        class="spinner-grow spinner-grow-sm"
                        role="status"
                        aria-hidden="true"
                  ></span>
                  Add
                </b-button>
              </div> <!-- End of ADD button -->

            </b-form>
          </ValidationObserver>
        </div>
      </div>
    </div> <!-- end of Add Raffle Identifier main div -->


    <div class="col-md-5 col-12" v-if="isEditMode"> <!-- start of Edit Raffle Identifier main div -->
      <div class="card">
        <div class="card-header text-dark fw-bold">
          Edit Raffle Identifier
        </div>
        <div class="card-body">
          <ValidationObserver v-slot="{ handleSubmit, reset }">
            <b-form @submit.prevent="handleSubmit(checkForm('edit'))"
                    @reset.prevent="reset">

              <div class="col-md-12">
                <label>Raffle Identifier Name <span class="text-danger">*</span></label>
                <b-form-input placeholder="Enter Raffle Identifier"
                              v-model="raffleDetails.raffleIdentifier"
                              class="form-control"
                              :class="{
                                  'is-invalid' : raffleFormValidation.raffleIdentifier
                              }"
                              @change="checkChangedValue('raffleIdentifier')"
                              trim
                ></b-form-input>
                <div v-if="raffleFormValidation.raffleIdentifier"
                     class="invalid-feedback">
                     This field is required
                </div>
              </div> <!-- End of raffleIdentifier field -->

              <div class="col-md-12 mt-3">
                <label class="form-label">Promo Duration <span class="text-danger">*</span></label>
                <flat-pickr placeholder="Select a date"
                            v-model="raffleDetails.promoDuration"
                            :config="rangeOptions"
                            class="form-control"
                            :class="{
                                'is-invalid' : raffleFormValidation.promoDuration
                            }"
                            @on-change="checkChangedValue('promoDuration')"
                            id="date-promo-duration"
                            required
                ></flat-pickr>
                <div v-if="raffleFormValidation.promoDuration"
                     class="invalid-feedback">
                     This field is required
                </div>
              </div> <!-- End of promoDuration field -->

              <div class="col-md-12 mt-3">
                <label class="form-label">Draw Date <span class="text-danger">*</span></label>
                <flat-pickr placeholder="Select a date"
                            v-model="raffleDetails.drawDate"
                            :config="{ minDate: raffleDetails.promoStartDate ? incrementEndDate : minDate, 
                                       maxDate: null, 
                                       enableTime: true, 
                                       dateFormat: 'Y-m-d h:i K' }"
                            class="form-control"
                            :class="{
                                'is-invalid' : raffleFormValidation.drawDate
                            }"
                            @on-change="checkChangedValue('drawDate')"
                            id="date-draw-date"
                            required
                ></flat-pickr>
                <div v-if="raffleFormValidation.drawDate"
                     class="invalid-feedback">
                     This field is required
                </div>
              </div> <!-- End of drawDate field -->

              <div class="row mt-4">
                <div class="col-md-6">
                  <b-button class="w-100"
                            type="submit"
                            variant="primary"
                            :disabled="isSubmitted">
                    <span v-if="isSubmitted"
                          class="spinner-grow spinner-grow-sm"
                          role="status"
                          aria-hidden="true"
                    ></span>
                    Update
                  </b-button>
                </div> <!-- End of UPDATE button -->

                <div class="col-md-6">
                  <b-button class="w-100"
                            type="button"
                            variant="light"
                            :disabled="isSubmitted"
                            @click="cancelEditRaffleIdentifier">
                    Cancel
                  </b-button>
                </div> <!-- End of CANCEL button -->
              </div> 

            </b-form>
          </ValidationObserver>
        </div>
      </div>
    </div> <!-- end of Edit Raffle Identifier main div -->


    <div class="col-md-7 col-12"> <!-- start of Raffle List main div -->
      <div class="card">
        <div class="card-header text-dark fw-bold">
          Raffle List ({{ raffleIdentifierList.length }})
        </div>
        <div class="card-body">
          <div class="table-responsive"> <!-- start of Raffle List data-table -->
            <div class="table align-middle table-nowrap">
              <b-table :items="raffleIdentifierList"
                       :fields="fieldsRaffleIdentifierList"
                       responsive="sm"
                       class="table-check">

                <template #cell(action)="data">
                  <div class="d-flex">
                    <div class="btn-group me-2 mb-2 mb-sm-0">
                      <button type="button" 
                              class="btn btn-sm btn-primary p-1"
                              @click="editRaffleIdentifier(data.item)"
                              :disabled="isDisableEdit(data.item.raffleStartDate)">
                              <i class="bx bx-edit bx-xs bx-fw"></i>
                      </button>
                    </div>
                    <div>
                      <b-button id="show-btn" 
                                class="btn btn-sm btn-danger p-1"
                                @click="deleteRaffleIdentifier(data.item)"
                                :disabled="data.item.prizesCount > 0">
                                <i class="bx bx-trash bx-xs bx-fw"></i>
                      </b-button>
                    </div>
                  </div>
                </template>

                <template #cell(raffleIdentifierName)="data">
                  <span>{{ data.item.raffleIdentifierName }}</span>
                </template>
                <template #cell(raffleDuration)="data">
                  <p class="text-body m-0 ">{{ data.item.raffleDuration }}</p>
                </template>
                <template #cell(raffleDrawDate)="data">
                  <p class="text-body m-0 ">{{ formatDate(data.item.raffleDrawDate) }}</p>
                </template>

              </b-table>
            </div>
          </div> <!-- end of Raffle List data-table -->

          <div class="row g-0 mb-1 text-center" v-if="isLoading">
            <span>Loading data...</span>
          </div>
          <div class="row g-0 text-center" v-if="!isLoading && raffleIdentifierList.length == 0">
            <span>No data to display.</span>
          </div>
          
        </div>
      </div>
    </div> <!-- end of Raffle List main div -->
  </div> <!-- end of outer div-->
</template>



<style>
  .btn-confirm {
    color: #545454 !important;
    border: 2px solid #B6B2EC !important;
    border-radius: 4px !important;
  }
</style>